import { Container } from "./styles/styled";

const ErrorModal = (props) => {
  return (
    <Container>
      <div className="popup-container-background">
        <div className="delete-exercise-popup-container">
          <div>
            <h2>Lo sentimos</h2>
            <h4>Ha ocurrido un error</h4>
          </div>
          <iframe src="https://lottie.host/embed/fb50038a-4722-4f1d-b2df-71191dd76010/3NlsHhLArC.lottie"></iframe>
          <div className="flex_center_space-between delete-exercise-popup-buttons-container">
            <a className="btn-primary ghost" href="/contact">
              Contactate
            </a>
            <a className="btn-primary" href={props.linkTo}>
              Aceptar
            </a>
          </div>
        </div>
      </div>
    </Container>
  );
};
export default ErrorModal;
